import { combineReducers } from 'redux';
import errorReducer from './errorReducer';
import userReducer from './userReducer';
import security from './security';
import roleReducer from './roleReducer';
import decisionReducer from './decisionReducer';
import decisionTypeReducer from './decisionTypeReducer';
import signetReducer from './signetReducer';
import submissionDataSignetReducer from './submissionDataSignetReducer';
import decisionTypeAttachmentReducer from './decisionTypeAttachmentReducer';
import submissionDataSignetLookReducer from './submissionDataSignetLookReducer';
import submissionDataSignetDestroyedReducer from './submissionDataSignetDestroyedReducer';
import decisionAttachmentReducer from './decisionAttachmentReducer';
import requestForSignetApprovalReducer from './requestForSignetApprovalReducer';
import autonomousProvinceReducer from './autonomousProvinceReducer';
import kjsReducer from './kjsReducer';
import placeReducer from './placeReducer';
import municipalityReducer from './municipalityReducer';
import institutionTypeReducer from './institutionTypeReducer';
import complementRequestApprovalReducers from './complementRequestApprovalReducers';
import viewAttachment from './viewAttachment';
import complementSignetReducer from './complementSignetReducer';
import requestForSignetStatusReducer from './requestForSignetStatusReducer';
import requestForSignetStatusAttachmentReducer from './requestForSignetStatusAttachmentReducer';
import signetExampleReducer from './signetExampleReducer';
import kjsMunicipalityReducer from './kjsMunicipalityReducer';

export default combineReducers({
  errors: errorReducer,
  loggedUser: security,
  user: userReducer,
  role: roleReducer,
  decision: decisionReducer,
  decisionType: decisionTypeReducer,
  signet: signetReducer,
  submissionDataSignet: submissionDataSignetReducer,
  decisionTypeAttachment: decisionTypeAttachmentReducer,
  decisionAttachment: decisionAttachmentReducer,
  requestForSignetApproval: requestForSignetApprovalReducer,
  submissionDataSignetLook: submissionDataSignetLookReducer,
  submissionDataSignetDestroyed: submissionDataSignetDestroyedReducer,
  autonomousProvince: autonomousProvinceReducer,
  kjs: kjsReducer,
  place: placeReducer,
  municipality: municipalityReducer,
  institutionType: institutionTypeReducer,
  complementRequestApproval: complementRequestApprovalReducers,
  viewAttachment: viewAttachment,
  complementSignet: complementSignetReducer,
  requestForSignetStatus: requestForSignetStatusReducer,
  requestForSignetStatusAttachment: requestForSignetStatusAttachmentReducer,
  signetExample: signetExampleReducer,
  kjsMunicipality: kjsMunicipalityReducer,
});
